import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setCurrentLang(lng);
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
    try {
      localStorage.setItem('i18nextLng', newLang);
    } catch {
      // ignore storage errors
    }
  };

  const isEnglish = currentLang === 'en';

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border border-background-200/70 hover:border-accent-300 bg-white/60 hover:bg-white transition-all duration-200 whitespace-nowrap cursor-pointer text-foreground-700 hover:text-foreground-950"
      aria-label={isEnglish ? 'Switch to Spanish' : 'Cambiar a inglés'}
    >
      <i className="ri-global-line text-sm" />
      <span>{isEnglish ? 'ES' : 'EN'}</span>
    </button>
  );
}